<div class="modal-heading modal-heading-1">
  <div class="label_name">
    <div class="modal-close-x" (click)="closeModal()">
      <fa-icon [icon]="['fas', 'times']"></fa-icon>
    </div>
    {{ 'IMAGE_VIEWER_MODAL.SOLUTION' | translate }}
  </div>
</div>
<div class="modal-body p-0">
  <img [src]="imageUrl" (click)="closeModal()" alt="">
</div>
<div class="modal-footer right">
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="closeModal()">{{ 'IMAGE_VIEWER_MODAL.CLOSE' | translate }}</button>
</div>
